"use client";

import React from "react";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { v4 } from "uuid";

import { Button, Text, Textarea, TextField } from "@aprosoja/ui";
import { contactFormSchema, type ContactFormValues } from "./contact-schema";
import { submitContact } from "@aprosoja/api";
import { useToastFeedbackUser } from "@aprosoja/stores";

const ContactForm = () => {
  const { setToast } = useToastFeedbackUser();
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<ContactFormValues>({
    resolver: zodResolver(contactFormSchema),
  });

  const handleSubmitForm = async (dataValues: ContactFormValues) => {
    try {
      await submitContact(dataValues);
      setToast({
        id: v4(),
        title: "Mensagem enviada com sucesso!",
        description: "Em breve entraremos em contato. Obrigado!",
        status: "success",
      });
      reset({ email: "", message: "", name: "", subject: "" });
    } catch (error) {
      setToast({
        id: v4(),
        title: "Erro ao enviar a mensagem",
        description: "Por favor tente novamente",
        status: "error",
      });
    }
  };

  return (
    <div className="w-full flex flex-col gap-size-x6">
      <Text type={"headingM"}>Formulário</Text>
      <form
        onSubmit={handleSubmit(handleSubmitForm)}
        className="w-full flex flex-col gap-size-x6"
      >
        <div className="w-full flex flex-col tabletLarge:flex-row gap-size-x6">
          <Controller
            name="name"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Nome completo"
                errorMessage={fieldState?.error?.message}
                onChange={field.onChange}
                size="large"
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="E-mail"
                type="email"
                errorMessage={fieldState?.error?.message}
                onChange={field.onChange}
                size="large"
              />
            )}
          />
        </div>
        <Controller
          name="subject"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Assunto"
              errorMessage={fieldState?.error?.message}
              onChange={field.onChange}
              size="large"
            />
          )}
        />
        <Controller
          name="message"
          control={control}
          render={({ field, fieldState }) => (
            <Textarea
              {...field}
              label="Escreva um comentário"
              errorMessage={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
        <div className="self-end">
          <Button
            size="large"
            className="w-[120px] rounded-border-radius-small"
            type="submit"
            loading={isSubmitting}
          >
            Enviar
          </Button>
        </div>
      </form>
    </div>
  );
};

export { ContactForm };
